<div class="title">О волейбольной лиге «Трудовые резервы»</div>
<div class="text">
  <p>
  С 29 марта по ноябрь в два этапа пройдёт второй сезон OLIMPBET Волейбольной Лиги «Трудовые Резервы» для корпоративных команд. Весенний этап пройдёт с 29 марта по 8 июня, осенний – с сентября по ноябрь.
  </p>
  <p>
  В соревнованиях участвуют 36 команды. На каждом матче будет работать профессиональный судейский корпус. Соревнования будут проходить в спортивном центре «Территория мяча» и на Арене спорта «Динамо».
  </p>
  <p>
  Команды будут играть в два круга по 2 матча, каждая с каждой. Из 36 команд будут сформированы 6 дивизионов по 6 команд. Каждая команда за сезон проведёт 10 матчей в своём дивизионе. Дивизион «Нептун» играет в на Арене спорта «Динамо» по четвергам, а Дивизион «Венера» – женский. Победитель Меркурия получит возможность участия в титульном мероприятии до конца 2025 года без взноса.
  </p>
  <p>
  Зрители и болельщики смогут наблюдать за встречами в прямом эфире официального аккаунта Лиги в группе в ВК. На чемпионате будет активно работать медиагруппа, которая обеспечит профессиональными фотоотчётами и обзорами лучших моментов с каждого матча.
  </p>
  <p>
  На протяжении всех матчей формируется статистика команд и отдельно каждого игрока на официальном сайте Лиги.
  </p>
  <p>
  Победители и призёры по итогам матчей группового этапа в каждом Дивизионе получают уникальные награды ВФСО «Трудовые резервы».
  </p>
</div>

<div class="statistic">
  <div class="item">
    <div class="name">
      Всего команд
      <br />
      в лиге
    </div>
    <div class="value">{{ statistic?.teams_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество игроков
      <br />
      в лиге
    </div>
    <div class="value">{{ statistic?.players_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      сыгранных игр
    </div>
    <div class="value">{{ statistic?.games_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      сыгранных сетов
    </div>
    <div class="value">{{ statistic?.sets_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      набранных очков
    </div>
    <div class="value">{{ statistic?.points_sum || 0 }}</div>
  </div>
</div>

<div class="join">
  Присоединяйся к Волейбольной Лиге "Трудовые резервы"
  <a href="javascript:;" class="btn" (click)="openJoinForm()">Присоединиться</a>
</div>
